<template>
  <div class="container">
    <div v-if="postInView == null">
      <div class="row">
        <div class="col">
          <div
            id="jumbo"
            class="jumbotron jumbotron-fluid"
            style="background-color: white; height: 30rem;"
          >
            <h1 class="text-white" style="margin-top: 7rem;">
              Funds Granted Blog
            </h1>
            <h3 class="text-white"></h3>
            <p
              class="text-secondary small"
              style="position:absolute; bottom: 1rem; right: 3rem;"
            >
              Photo by
              <a
                class="text-secondary"
                target="_blank"
                rel="noopener noreferrer"
                href="https://unsplash.com/@christinhumephoto"
                >Christin Hume</a
              >
              on
              <a
                class="text-secondary"
                target="_blank"
                rel="noopener noreferrer"
                href="www.unsplash.com"
                >Unsplash</a
              >
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-auto pr-0 pt-1">
              <label>Filter Categories:</label>
            </div>
            <div class="col-auto">
              <select
                id="category"
                name="categoryPicker"
                class="form-control selectpicker"
                data-style="btn-outline-primary"
                multiple
                data-live-search="true"
                data-actions-box="true"
                data-selected-text-format="count"
                data-none-selected-text="All Categories"
                v-model="filterByCategory"
              >
                <option
                  v-for="category in categories.slice().sort()"
                  :key="category.Category_Id + 'category'"
                  v-bind:value="category"
                  >{{ category.Name }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-auto pr-0 pt-1">
              <label>Search:</label>
            </div>
            <div class="col-auto">
              <input
                class="form-control form-control-sm"
                type="text"
                v-model="searchKeyword"
                placeholder="Search"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="my-3" style="height: 2px; background-color: gray;" />
      <masonry
        :cols="{ default: 4, 1000: 3, 800: 2, 500: 1 }"
        :gutter="{ default: '30px', 700: '15px' }"
      >
        <div
          class="card mb-4 pointer"
          v-for="post in filterPosts()"
          :key="post.Blog_Post_Id"
          v-on:click="viewPost(post)"
        >
          <img
            v-bind:src="post.Thumbnail_Picture"
            class="card-img-top"
            alt="img"
          />
          <div class="card-body" style="background-color: #FAFAFA">
            <h5 class="card-title mb-1">{{ post.Title }}</h5>
            <p class="text-secondary small mb-0">
              {{ post.Author.First_Name }} {{ post.Author.Last_Name }}
            </p>
            <p class="text-secondary small mb-2">
              {{
                new Date(post.Release_Date).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric"
                })
              }}
            </p>
            <p class="card-text small">{{ post.Summary }}</p>
          </div>
        </div>
      </masonry>
    </div>
    <div v-else>
      <div class="row">
        <div class="col text-left">
          <div
            id="postJumbo"
            class="jumbotron jumbotron-fluid"
            style="background-color: white; height: 20rem;"
            v-bind:style="{
              backgroundImage: `url(${postInView.Header_Picture})`
            }"
          ></div>
          <h3>{{ postInView.Title }}</h3>
          <p class="text-secondary small">
            {{
              new Date(postInView.Release_Date).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric"
              })
            }}
            / {{ postInView.Author.First_Name }}
            {{ postInView.Author.Last_Name }}
          </p>
          <p v-html="postInView.Post" />
        </div>
        <div class="col-3 text-left">
          <button
            class="btn btn-link text-secondary text-left"
            v-on:click="postInView = null"
          >
            Back to All
          </button>
          <h3>Recent Posts</h3>
          <div v-for="post in blogPosts.slice(0, 5)" :key="post.Blog_Post_Id">
            <button
              class="btn btn-link text-secondary text-left"
              v-on:click="viewPost(post)"
            >
              {{ post.Title }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      blogPosts: [],
      categories: [],
      postInView: null,
      backCallHappening: false,
      filterByCategory: [],
      searchKeyword: ""
    };
  },
  components: {},
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    document.addEventListener("backbutton", this.backCall, false);
    try {
      view.$data.blogPosts = await view.$getReleasedBlogPosts();
      view.$data.categories = await view.$getAllCategories();
      view.$store.commit("updateLoading", false);
    } catch (err) {
      console.log(err);
      view.$store.commit("updateLoading", false);
    }
    window.addEventListener("popstate", this.backCall, false);
    $(".selectpicker").selectpicker("refresh");
  },
  beforeRouteLeave(to, from, next) {
    setTimeout(() => {
      if (this.backCallHappening && this.postInView != null) {
        this.postInView = null;
        this.backCallHappening = false;
        next(false);
      } else {
        next();
      }
    }, 100);
  },
  methods: {
    filterPosts() {
      var filteredPosts = this.blogPosts;
      if (this.filterByCategory.length > 0) {
        console.log(filteredPosts);
        filteredPosts = filteredPosts.filter(s =>
          this.filterByCategory.some(c =>
            s.Categories.map(sc => sc.Category_Id).includes(c.Category_Id)
          )
        );
      }
      if (this.searchKeyword != "") {
        var search = this.searchKeyword.toLowerCase();
        filteredPosts = filteredPosts.filter(
          s =>
            s.Title.toLowerCase().includes(search) ||
            s.Summary.toLowerCase().includes(search)
        );
      }
      return filteredPosts;
    },
    async viewPost(post) {
      this.$store.commit("updateLoading", true);
      await this.$getBlogPost(post.Blog_Post_Id).then(gottenPost => {
        this.postInView = gottenPost;
        this.$store.commit("updateLoading", false);
      });
    },
    backCall() {
      this.backCallHappening = true;
    }
  }
};
</script>

<style scoped>
#jumbo {
  background-image: url("https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-1.2.1&auto=format&fit=crop&w=3300&q=80");
  background-repeat: no-repeat;
  background-size: cover;
}
#postJumbo {
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
